// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-title{font-size:1.3rem;font-weight:700}`, "",{"version":3,"sources":["webpack://./src/components/sidebar-menus/sidebar-panel/sidebar-title.css"],"names":[],"mappings":"AAAA,eAEC,gBAAiB,CADjB,eAED","sourcesContent":[".sidebar-title {\n\tfont-weight: bold;\n\tfont-size: 1.3rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
